// extracted by mini-css-extract-plugin
export default {"root":"ResultsBadge_root__JeKIg","title":"ResultsBadge_title__aapsR"};